import React from 'react';

import useTranslateLpc from '@components/common/hooks/useTranslateLpc';

import css from './Details.module.scss';

const Details = () => {
    const { t } = useTranslateLpc('lpc-report');
    return (
        <>
            <>
                <div className={css.details_container}>
                    <h4>{t('details.desc-1')}</h4>
                    <div className={css.divider} />
                    <h4>{t('details.desc-2')}</h4>
                </div>
            </>
        </>
    );
};

export default Details;
